import React from 'react';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import { Grid, ListItem, List, TextField, Button, FormControl, InputLabel, Select, Input, MenuItem, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import Chart from 'react-google-charts'
import FromServer from './FromServer';


export default class RapoartePeUtilizatori extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            dataStart: new Utils().defaultDataMinus1Months(),
            dataFinish: new Utils().defaultData(),
            sortBy: 'nrTotalTaskuri', //aceleasi ca cheile obiectului analize1,
            listRaport: [],
            sortByList: new Utils().sortByUserReports,
            chartData: [],
            chartData2: []
        }
    }

    componentDidMount() {
    }


    listRaport = []
    listRaportGroupedByUser = []


   
    sortBy = (ev) => {
        this.setState({ sortBy: ev.target.value }, () => {
            this.sortDs()
        })
    }


    sortDs =async () => {

        let fs = new FromServer()

        let getRaport = await fs.getRaportUtilizatori(this.state.sortBy)

        // console.log('getRaport :', getRaport);

        this.setState({
            listRaport: getRaport.s,
            chartData: getRaport.chartData,
            chartData2: getRaport.chartData2
        }, () => {
            // console.log('this.state.listRaport :', this.state.listRaport);
        })
    }


   


    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.rapoarte} />


                <div className='container'>
                    <h2 className='pm-title'>Raport utilizatori si proiecte pe interval de timp</h2>
                    <Grid container>


                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label={this.dictionary.proiecte.informatiiProiect.deLa}
                                value={this.state.dataStart || ''}
                                onChange={(ev) => { this.setState({ dataStart: ev.target.value }) }}
                                margin="normal"
                                type='date'
                            />

                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label={this.dictionary.proiecte.informatiiProiect.panaLa}
                                value={this.state.dataFinish || ''}
                                onChange={(ev) => { this.setState({ dataFinish: ev.target.value }) }}
                                margin="normal"
                                type='date'
                            />

                        </Grid>

                        <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Button variant="outlined" onClick={this.sortDs} className='pm-save-button'>
                                Executa
                          </Button>
                        </Grid>



                    </Grid>
                </div>

                {this.state.listRaport.length > 0 &&

                    <div className='container' style={{ textAlign: 'right', }}>
                        <FormControl className='inputFocus' style={{ width: 150, marginRight: 20, marginBottom: 20 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.proiecte.rapoarteProiect.ordoneazaDupa}</InputLabel>
                            <Select

                                value={this.state.sortBy || ""}
                                onChange={(ev) => { this.sortBy(ev) }}

                                input={<Input id="resursa" />}>


                                {this.state.sortByList.map((t, idx) => {
                                    return <MenuItem value={t.id} key={idx}  > {t.nume}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                        <div style={{ marginTop: 30, marginBottom: 20, overflow: 'auto', width: '100%' }}>

                            <h2 className='pm-title'>Informatii Generale</h2>

                            <Table className='pm-indicatori-table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {this.dictionary.proiecte.etapeProiect.numeEtapa}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreCumulateTaskuri}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreDiferentaCompletare}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreAvansCompletare}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.pctDepasire}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.pctAvans}
                                        </TableCell>
                                        <TableCell>
                                            Expl
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {this.state.listRaport.map((e, idx) => {
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.numeUser}
                                                </TableCell>

                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.totalOreCumulateTaskuri}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {!String(e.totalOreDiferentaCompletare).includes('-') &&
                                                        <span>{Math.abs(Number(e.totalOreDiferentaCompletare))}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {String(e.totalOreDiferentaCompletare).includes('-') &&
                                                        <span>{Math.abs(Number(e.totalOreDiferentaCompletare))}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                {!String(e.pctDepasire).includes('-') &&
                                                        <span>{Math.abs(Number(e.pctDepasire))}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                {String(e.pctDepasire).includes('-') &&
                                                        <span>{Math.abs(Number(e.pctDepasire))}</span>
                                                    }
                                                </TableCell>
                                                <TableCell >
                                                    {String(e.pctDepasire).includes('-') &&
                                                        <span style={{ color: 'green' }}>Utilizatorul termina majoritatea taskurilor inainte de termen
                                                                cu aproximativ {e.pctDepasire}%.</span>}
                                                    {!String(e.pctDepasire).includes('-') &&
                                                        <span style={{ color: 'pink' }}>Utilizatorul de regula depaseste taskurile
                                                                cu aproximativ {e.pctDepasire}%.</span>}
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}


                                </TableBody>
                            </Table>




                        </div>

                        <Chart
                            width={'100%'}
                            height={'500px'}
                            chartType='BarChart'

                            data={this.state.chartData2

                            }
                            options={{
                                title: 'Grafic General',

                            }}

                        />

                        <h2 className='pm-title'>Informatii Detaliate</h2>

                        <div style={{ marginTop: 30, marginBottom: 20, overflow: 'auto', width: '100%' }}>



                            <Table className='pm-indicatori-table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {this.dictionary.proiecte.etapeProiect.numeEtapa}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.medieGenerala}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.calificativMedie}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.medieAvansPerTask}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.medieDepasirePerTask}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.nrTaskuriAvans}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.nrTaskuriDepasite}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.nrTaskuriTermen}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.nrTotalTaskuri}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreAvans}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreDepasire}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreCumulateTaskuri}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreDiferentaCompletare}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.pctDepasire}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {this.state.listRaport.map((e, idx) => {
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.numeUser}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.medieGenerala}
                                                </TableCell>
                                                <TableCell>

                                                    <i style={{ color: e.calificativMedie === 'Pozitiva' ? 'green' : 'red' }}
                                                        className='material-icons'>{e.calificativMedie === 'Pozitiva' ? 'arrow_upward' : 'arrow_downward'}</i>
                                                    {e.calificativMedie}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.medieAvansPerTask}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.medieDepasirePerTask}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.nrTaskuriAvans}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.nrTaskuriDepasite}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.nrTaskuriInTermen}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.nrTotalTaskuri}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.totalOreAvans}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.totalOreDepasire}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.totalOreCumulateTaskuri}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.totalOreDiferentaCompletare}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.pctDepasire}
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}


                                </TableBody>
                            </Table>




                        </div>
                         <p style={{textAlign:'left'}}>*<b>Legenda</b> </p>
                         <p style={{textAlign:'left'}}>Valorile negative ale procentajelor sau orelor depasite inseamna activitati terminate in avans</p>
                        <Chart
                            width={'100%'}
                            height={'500px'}
                            chartType='BarChart'

                            data={this.state.chartData

                            }
                            options={{
                                title: 'Grafic Detaliat',

                            }}

                        />




                    </div>

                }

            </div>
        );
    }
}